import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Finance from './Finance';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Finance | Admin',
    component: (
      <AdminLayout>
        <Finance />
      </AdminLayout>
    ),
  };
}

export default action;
